<template>
  <div v-editable="blok" class="container blogpost">
    <BlogPostTop
      :title="blok.custom_heading || blok.meta?.title"
      :authors="blok.authors"
      :date="blogStore.date"
      :raw-date="blogStore.rawDate"
      :text-override="blok.breadcrumb_text"
    />
    <div class="blogpost__wrapper">
      <BlogPostSocial :meta="blok.meta" />
      <div class="blogpost__content container container--blog">
        <StoryblokComponent
          v-for="childBlok in blok.content"
          :key="childBlok._uid"
          :blok="childBlok"
        />
      </div>
    </div>
    <BlogPostBottom
      :authors="blogStore.authorsData"
      :categories="blogStore.categoriesData"
    />
  </div>
</template>

<script lang="ts" setup>
import type { SbPageStoryblok } from '@/types'

interface Props {
  blok: SbPageStoryblok
}

defineProps<Props>()
const blogStore = useBlogStore()
</script>

<style lang="scss" scoped>
.blogpost {
  padding-top: 36px;
  position: relative;
  @media (min-width: $breakpoint-md) {
    --container-padding: 54px;
  }
  @media (min-width: $breakpoint-lg) {
    --container-padding: 20px;
  }

  &__wrapper {
    @media (min-width: $breakpoint-lg) {
      display: flex;
      align-items: flex-start;
    }
  }

  &__content {
    margin-bottom: 40px;

    @media (min-width: $breakpoint-lg) {
      margin-bottom: 64px;
    }
  }
}
</style>

<!-- These are styles reserved for WYSIWYG in blogpost component. -->
<!-- Link to figma: https://www.figma.com/file/w4PzT8VxwxmeBsUzZgqxsO/Brand-%2F-Style-Guide?node-id=4974-5969&t=nlU99jWmbsxZztqS-0 -->
<style lang="scss">
.blogpost .richtext {
  h2 {
    @include heading-3;

    margin-bottom: 32px;
  }

  h3 {
    @include heading-4;

    margin-bottom: 24px;
  }

  p + h2 {
    padding-top: 36px;
  }

  p + h3 {
    padding-top: 36px;
  }

  p {
    margin-bottom: 20px;
  }

  p:last-of-type {
    margin-bottom: 0;
  }
}
</style>
